import { ref, update } from "firebase/database";
import { useState } from "react";
import { db } from "../Firebase";

const HoldAction = ({ registrationId, currentStatus, onSuccess, buttonText = "⏸️ Hold", buttonClass = "btn-warning" }) => {
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleHold = async () => {
    if (!reason.trim()) {
      return alert('कारण आवश्यक है (Reason is required)');
    }

    setLoading(true);
    try {
      const updateData = {
        [`meta/status`]: 'hold',
        [`meta/holdAt`]: new Date().toISOString(),
        [`meta/holdReason`]: reason.trim()
      };

      await update(ref(db, `registration/${registrationId}`), updateData);
      
      setShowModal(false);
      setReason('');
      alert('Registration put on hold successfully!');
      if (onSuccess) onSuccess();
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className={`btn btn-sm ${buttonClass}`}
        onClick={() => setShowModal(true)}
        disabled={currentStatus === 'hold'}
      >
        {buttonText}
      </button>

      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">⏸️ Hold Registration</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">कारण (Reason) *</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Hold का कारण लिखें..."
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button 
                  className="btn btn-warning" 
                  onClick={handleHold}
                  disabled={loading}
                >
                  {loading ? 'Processing...' : 'Confirm Hold'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HoldAction;